<script setup lang="ts">
import type { SiteBlockData, SiteBlockSettings } from '../../../types/site'

defineProps<{ data: SiteBlockData, settings: SiteBlockSettings }>()
</script>

<template>
  <div>
    <SiteSectionHeading
      :eyebrow="data.eyebrow"
      :title="data.headline"
      class="mb-8"
    />
    <div
      v-if="data.stats?.length"
      class="flex flex-wrap justify-center gap-x-12 gap-y-8"
    >
      <div
        v-for="(stat, i) in data.stats"
        :key="i"
        class="min-w-[110px] text-center"
      >
        <p class="site-display text-3xl font-bold text-[var(--site-accent)] sm:text-4xl">
          {{ stat.value }}
        </p>
        <p class="mt-1 text-sm text-[var(--site-muted)]">
          {{ stat.label }}
        </p>
      </div>
    </div>
  </div>
</template>
